webpackJsonp([187008205646598],{

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(121);
	var isArguments = __webpack_require__(120);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 120:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 121:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(134);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(119);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(131);
	
	var _HelmetConstants = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 64:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(13);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(122);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(136);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 1395:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/deaths.7db72ab8.png";

/***/ }),

/***/ 1402:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/obesity.426308a7.png";

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  fill: "none",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M142.487 217.796l-38.905 48.943h392.297l-38.901-48.943z",
	  fill: "#f47920"
	}), _react2.default.createElement("path", {
	  d: "M109.73 416.526h380.004v-142.27H109.73z",
	  fill: "#fff"
	}), _react2.default.createElement("path", {
	  d: "M101.95 424.308H497.51V266.475H101.95zm15.561-15.563h364.442V282.037H117.51z",
	  fill: "#5a5e68"
	}), _react2.default.createElement("path", {
	  d: "M191.035 392.21H408.43V144.576H191.035z",
	  fill: "#fff"
	}), _react2.default.createElement("path", {
	  d: "M198.813 384.43h201.83V152.356h-201.83zm-15.559 15.562H416.21V136.795H183.254z",
	  fill: "#5a5e68"
	}), _react2.default.createElement("path", {
	  d: "M107.781 418.211h383.902v-26H107.781z",
	  fill: "#fff"
	}), _react2.default.createElement("g", {
	  fill: "#5a5e68"
	}, _react2.default.createElement("path", {
	  d: "M100 425.992h399.464V384.43H100zm15.562-15.562h368.344v-10.435H115.562zM128.545 320.258h15.562V299.51h-15.562zM155.13 320.258h15.562V299.51h-15.563zM128.545 351.383h15.562v-20.749h-15.562zM155.13 351.383h15.562v-20.749h-15.563zM428.769 320.258h15.562V299.51h-15.562zM455.353 320.258h15.562V299.51h-15.562zM428.769 351.383h15.562v-20.749h-15.562zM455.353 351.383h15.562v-20.749h-15.562zM218.355 275.517h15.562v-20.749h-15.562zM247.791 275.517h15.562v-20.749h-15.562zM277.231 275.517h15.562v-20.749h-15.562zM306.67 275.517h15.563v-20.749h-15.562zM336.11 275.517h15.563v-20.749h-15.562zM365.547 275.517h15.562v-20.749h-15.562zM218.355 313.45h15.562V292.7h-15.562zM247.791 313.45h15.562V292.7h-15.562zM277.231 313.45h15.562V292.7h-15.562zM306.67 313.45h15.563V292.7h-15.562zM336.11 313.45h15.563V292.7h-15.562zM365.547 313.45h15.562V292.7h-15.562zM218.355 201.596h15.562v-20.749h-15.562zM247.791 201.596h15.562v-20.749h-15.562zM277.231 201.596h15.562v-20.749h-15.562zM306.67 201.596h15.563v-20.749h-15.562zM336.11 201.596h15.563v-20.749h-15.562zM365.547 201.596h15.562v-20.749h-15.562zM218.355 239.529h15.562V218.78h-15.562zM247.791 239.529h15.562V218.78h-15.562zM277.231 239.529h15.562V218.78h-15.562zM306.67 239.529h15.563V218.78h-15.562zM336.11 239.529h15.563V218.78h-15.562zM365.547 239.529h15.562V218.78h-15.562z"
	})), _react2.default.createElement("path", {
	  d: "M179.726 145.222h240.013v-32.53H179.726z",
	  fill: "#fff"
	}), _react2.default.createElement("path", {
	  d: "M187.507 137.44h224.45v-16.966h-224.45zm-15.563 15.563H427.52V104.91H171.944z",
	  fill: "#5a5e68"
	}), _react2.default.createElement("path", {
	  d: "M231 384.43h137.465v-48.944H230.999z",
	  fill: "#4abcbc"
	}), _react2.default.createElement("path", {
	  d: "M339.285 125.313c0 21.841-17.71 39.551-39.555 39.551-21.842 0-39.552-17.71-39.552-39.551 0-21.846 17.71-39.556 39.552-39.556 21.845 0 39.555 17.71 39.555 39.556",
	  fill: "#fff"
	}), _react2.default.createElement("path", {
	  d: "M299.732 93.538c-17.52 0-31.775 14.255-31.775 31.775s14.255 31.77 31.775 31.77 31.774-14.251 31.774-31.77-14.255-31.775-31.774-31.775m0 79.107c-26.098 0-47.337-21.234-47.337-47.332 0-26.102 21.239-47.337 47.337-47.337s47.336 21.235 47.336 47.337c0 26.098-21.238 47.332-47.336 47.332",
	  fill: "#5a5e68"
	}), _react2.default.createElement("path", {
	  d: "M291.949 145.61h15.562v-40.594H291.95z",
	  fill: "#5a5e68"
	}), _react2.default.createElement("path", {
	  d: "M279.433 133.095h40.594v-15.563h-40.594z",
	  fill: "#5a5e68"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 600 600"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "st0",
	  d: "M185.83 6.17H139.8c-4.42 0-8 3.58-8 8s3.58 8 8 8h26.72l-27.97 27.97c-3.12 3.12-3.12 8.19 0 11.31 1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.66-2.34l27.97-27.97V60.2c0 4.42 3.58 8 8 8s8-3.58 8-8V14.17c-.01-4.42-3.59-8-8.01-8z"
	});
	
	var _ref2 =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  className: "st0",
	  d: "M185.83 108.54c-4.42 0-8 3.58-8 8v61.29h-19.59V100.8h-31.63v77.04h-10.34v-43.16H84.63v43.16H73.39V65.22H41.76v112.61H22.17V22.17h73.06c4.42 0 8-3.58 8-8s-3.58-8-8-8H14.17c-4.42 0-8 3.58-8 8v171.67c0 4.42 3.58 8 8 8h171.67c4.42 0 8-3.58 8-8v-69.29c-.01-4.43-3.59-8.01-8.01-8.01z"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    id: "Layer_1",
	    viewBox: "0 0 200 200"
	  }, props), _ref, _ref2);
	};
	
	exports.default = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjIuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyMDAgMjAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMDAgMjAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0Y0NzkyMDt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE4NS44Myw2LjE3SDEzOS44Yy00LjQyLDAtOCwzLjU4LTgsOHMzLjU4LDgsOCw4aDI2LjcybC0yNy45NywyNy45N2MtMy4xMiwzLjEyLTMuMTIsOC4xOSwwLDExLjMxCgkJYzEuNTYsMS41NiwzLjYxLDIuMzQsNS42NiwyLjM0czQuMDktMC43OCw1LjY2LTIuMzRsMjcuOTctMjcuOTdWNjAuMmMwLDQuNDIsMy41OCw4LDgsOHM4LTMuNTgsOC04VjE0LjE3CgkJQzE5My44Myw5Ljc1LDE5MC4yNSw2LjE3LDE4NS44Myw2LjE3eiIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE4NS44MywxMDguNTRjLTQuNDIsMC04LDMuNTgtOCw4djYxLjI5aC0xOS41OVYxMDAuOGgtMzEuNjN2NzcuMDRoLTEwLjM0di00My4xNkg4NC42M3Y0My4xNkg3My4zOVY2NS4yMgoJCUg0MS43NnYxMTIuNjFIMjIuMTdWMjIuMTdoNzMuMDZjNC40MiwwLDgtMy41OCw4LThzLTMuNTgtOC04LThIMTQuMTdjLTQuNDIsMC04LDMuNTgtOCw4djE3MS42N2MwLDQuNDIsMy41OCw4LDgsOGgxNzEuNjcKCQljNC40MiwwLDgtMy41OCw4LTh2LTY5LjI5QzE5My44MywxMTIuMTIsMTkwLjI1LDEwOC41NCwxODUuODMsMTA4LjU0eiIvPgo8L2c+Cjwvc3ZnPgo=";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(130);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ThemeList = __webpack_require__(66);
	
	var _ThemeList2 = _interopRequireDefault(_ThemeList);
	
	var _PageHeader = __webpack_require__(109);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _ThemeNavFooter = __webpack_require__(110);
	
	var _ThemeNavFooter2 = _interopRequireDefault(_ThemeNavFooter);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ShareExhibit = __webpack_require__(92);
	
	var _ShareExhibit2 = _interopRequireDefault(_ShareExhibit);
	
	var _caseStudyHospitalMortality = __webpack_require__(188);
	
	var _caseStudyHospitalMortality2 = _interopRequireDefault(_caseStudyHospitalMortality);
	
	var _iconChart = __webpack_require__(111);
	
	var _iconChart2 = _interopRequireDefault(_iconChart);
	
	var _deaths = __webpack_require__(1395);
	
	var _deaths2 = _interopRequireDefault(_deaths);
	
	var _obesity = __webpack_require__(1402);
	
	var _obesity2 = _interopRequireDefault(_obesity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Theme3Page = function Theme3Page(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: '' + data.allThemesJson.edges[2].node.title
	    }),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(_PageHeader2.default, {
	        data: data.allThemesJson.edges[2].node,
	        img: _deaths2.default
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content section__summary' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'The COVID-19 pandemic has triggered a public health and economic crisis at a time when American health outcomes were already moving in the wrong direction. Decades long gains in life expectancy reversed after 2014, and adults of all races and ethnicities have been dying at increased rates.',
	            _react2.default.createElement(
	              'sup',
	              { className: 'note__link' },
	              _react2.default.createElement(
	                'a',
	                { href: '#19' },
	                '19'
	              )
	            ),
	            ' These trends are likely to continue in the wake of more than 185,000 COVID-19 deaths, and they may be exacerbated by the deep decline in the use of health care services unrelated to the disease and the greatest increase in unemployment since the Great Depression.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'Deaths from suicide, alcohol, and drug overdose'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Deaths from suicide, alcohol, and drug overdose have all climbed over the past few decades and have been an important contributor to recent mortality trends.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '#20' },
	                  '20'
	                )
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/deaths/#exhibit-8' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'exhibit__link' },
	                  _react2.default.createElement(_iconChart.ReactComponent, null)
	                )
	              ),
	              'These types of death differ significantly in terms of regional impact. ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/deaths/#exhibit-9' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'exhibit__link' },
	                  _react2.default.createElement(_iconChart.ReactComponent, null)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Opioids have been a critical driver, particularly since 2012, when the impact of synthetic opioids like fentanyl expanded. Since then, synthetic opioid overdoses have grown from 6 percent of all overdose deaths to nearly half. ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/deaths/#exhibit-10' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'exhibit__link' },
	                  _react2.default.createElement(_iconChart.ReactComponent, null)
	                )
	              ),
	              ' In 2018, the U.S. reported its first significant decline in drug overdose deaths in decades; however, the rate of synthetic opioid overdose deaths increased another 10 percent. Ten states and the District of Columbia attributed more than 20 deaths per 100,000 people to this cause. Unfortunately, preliminary estimates from the Centers for Disease Control and Prevention also show that drug overdose deaths jumped again in 2019, despite recent federal support and state efforts (preliminary 2019 data not shown in Exhibit 8).',
	              _react2.default.createElement(
	                'sup',
	                {
	                  className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#21' },
	                  '21'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Research indicates that higher local unemployment or economic shocks may be associated with increased overdose deaths from opioids or other drugs, as well as poor mental health.',
	              _react2.default.createElement(
	                'sup',
	                {
	                  className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#22' },
	                  '22'
	                )
	              ),
	              ' Experts have warned about potential consequences from COVID-19 on so-called deaths of despair, and recent reports indicate increases in overdose deaths in 2020.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '#23' },
	                  '23'
	                )
	              ),
	              ' The 38 states that, along with the District of Columbia, have expanded their Medicaid programs are much better prepared to address a pandemic-related rise in substance use. Studies have found that the ACA\u2019s Medicaid expansion is associated with improvement in access to mental health care,',
	              _react2.default.createElement(
	                'sup',
	                {
	                  className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#24' },
	                  '24'
	                )
	              ),
	              ' greater access to medication-assisted treatment,',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '#25' },
	                  '25'
	                )
	              ),
	              ' and fewer opioid-related overdose deaths and hospitalizations.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#26' },
	                  '26'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'section__content section__content__wide ' },
	            _react2.default.createElement(
	              'div',
	              { id: 'exhibit-8', className: 'section__exhibit__padded section__exhibit' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'exhibit__title__block' },
	                'Suicide and alcohol deaths rose modestly in 2018. Though drug overdoses dropped for the first time in decades, preliminary 2019 data shows that they have jumped back up'
	              ),
	              _react2.default.createElement(
	                'figure',
	                null,
	                _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-8-web.png'), alt: '' }),
	                _react2.default.createElement(
	                  'figcaption',
	                  null,
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Note: Preliminary 2019 drug overdose data from the CDC is not included in this exhibit (see text).'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Data: 2005\u20132018 National Vital Statistics System (NVSS), via CDC WONDER.'
	                  )
	                )
	              ),
	              _react2.default.createElement(_ShareExhibit2.default, {
	                exhibit: 'exhibit-08',
	                site: data.site.siteMetadata,
	                social: data.allSocialJson.edges
	              })
	            ),
	            _react2.default.createElement('hr', { className: 'section__divider' }),
	            _react2.default.createElement(
	              'div',
	              { id: 'exhibit-9', className: 'section__exhibit__padded section__exhibit' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'exhibit__title__block' },
	                'Deaths from suicide, alcohol, and drug overdoses display significant regional variation'
	              ),
	              _react2.default.createElement(
	                'figure',
	                null,
	                _react2.default.createElement('img', { className: 'exhibit__image__padded',
	                  src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-9-web.png'), alt: '' }),
	                _react2.default.createElement(
	                  'figcaption',
	                  null,
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Note: District of Columbia not included in legend counts.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Data: 2018 National Vital Statistics System (NVSS), via CDC WONDER.'
	                  )
	                )
	              ),
	              _react2.default.createElement(_ShareExhibit2.default, {
	                exhibit: 'exhibit-09',
	                site: data.site.siteMetadata,
	                social: data.allSocialJson.edges
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-10', className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'Opioids contributed heavily to the overall rise in overdose deaths between 2009 and 2018, largely due to synthetic opioids'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { className: 'exhibit__image__padded', src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-10-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Note: Data categories are overlaid, not stacked/aggregated; synthetic opioid deaths are from synthetic opioids other than methadone.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: 2009\u20132018 National Vital Statistics System (NVSS), via CDC WONDER'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-10',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges
	          })
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'Premature deaths from treatable conditions'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Americans can expect to live a shorter life today than they did in 2014.',
	              _react2.default.createElement(
	                'sup',
	                {
	                  className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#27' },
	                  '27'
	                )
	              ),
	              ' A number of factors contribute to this decline, including deaths from suicide, alcohol, and drug overdose, but another is premature deaths from health care\u2013treatable conditions \u2014 also known as mortality amenable to health care. The Scorecard tracks deaths before age 75 from acute and chronic causes that are considered treatable when they are identified early and well managed; examples include appendicitis, certain cancers, heart disease, and diabetes, among others. Higher mortality rates in these categories point to deficiencies in the health system.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Between 2012\u20132013 and 2016\u20132017, these mortality rates either increased slightly or were unchanged in 37 states.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#28' },
	                  '28'
	                )
	              ),
	              ' Oklahoma, Arkansas, New Mexico, Kentucky, and Mississippi saw the biggest rise in premature deaths. States with the highest premature death rates also have lower life expectancies, ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/deaths/#exhibit-11' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'exhibit__link' },
	                  _react2.default.createElement(_iconChart.ReactComponent, null)
	                )
	              ),
	              ' and recent research linked life expectancy disparities to specific state policy choices.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#29' },
	                  '29'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Black Americans, who have suffered disproportionately from the pandemic, are much more likely to die from some of these conditions, several of which are key risk factors for COVID-19.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '#30' },
	                  '30'
	                )
	              ),
	              ' Significant racial disparities in mortality amenable to health care exist in nearly every state. ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/deaths/#exhibit-12' },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    className: 'exhibit__link' },
	                  _react2.default.createElement(_iconChart.ReactComponent, null)
	                )
	              ),
	              ' The pandemic threatens to exacerbate these trends even further through the disruption of primary care and other critical health services. Early data suggest elevated mortality from non-COVID-19 causes.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '#31' },
	                  '31'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-11',
	            className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'Premature deaths from treatable conditions are closely linked to the wide variation in state life expectancy'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { className: 'exhibit__image__padded',
	              src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-11-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: Life Expectancy: United States Mortality Database, University of California, Berkeley; available at usa.mortality.org (data shown on 2020-05-11 12:22:03). Mortality Amenable to Health Care: Centers for Disease Control and Prevention, 2016 and 2017 National Vital Statistics System (NVSS), All-County Micro Data, Restricted Use Files'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-11',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges
	          })
	        ),
	        _react2.default.createElement('hr', { className: 'section__divider' }),
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-12',
	            className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            ' In every state, Black people are more likely to die early from treatable conditions, 2016\u201317'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { className: 'exhibit__image__padded',
	              src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-12-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Notes: Data for Black individuals not available for Idaho, Montana, Vermont, or Wyoming. States arranged in rank order based on Black mortality rates.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: CDC 2016 and 2017 National Vital Statistics System (NVSS), All-County Micro Data, Restricted Use Files'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-12',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges
	          })
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'Public health investment.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'States are navigating unprecedented public health threats from COVID-19, as well as economic disruptions that have shrunk the tax revenues used to fund critical health and social services. But historically, most states have made only modest investments in their public health systems.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Between 2014\u20132015 and 2017\u20132018, per capita public health spending was flat in most states, and increases were modest in the states where funding did rise. ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/deaths/#exhibit-13' },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    className: 'exhibit__link' },
	                  _react2.default.createElement(_iconChart.ReactComponent, null)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Not only is public health funding low relative to other health care spending, but public health dollars are stretched thin. Competing for funding are various initiatives for emergency preparedness, disease prevention, promoting healthy behaviors, and, increasingly, fighting the opioid epidemic.',
	              _react2.default.createElement(
	                'sup',
	                {
	                  className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#32' },
	                  '32'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'exhibit-13',
	            className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'Most states have seen modest changes in per capita public health spending in recent years'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { className: 'exhibit__image__padded',
	              src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-13-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Notes: Estimates here include only state-based funding; federal public health funds are not included.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: 2017\u20132018 estimates: Trust for America\u2019s Health, The Impact of Chronic Underfunding on America\u2019s Public Health System: Trends, Risks, and Recommendations, 2019 (TFAH, Apr. 2019); 2014\u20132015 estimates: Trust for America\u2019s Health, Investing in America\u2019s Health: A State-by-State Look at Public Health Funding and Key Health Facts (TFAH, Apr. 2016).'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-13',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__heavy' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'What Can Be Done?'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Robust primary care systems are critical for addressing deaths from treatable chronic conditions that contribute to current mortality trends. States can pursue policies to increase primary care utilization, which is low across the U.S. They can also work to ensure access to mental health care, addiction treatment and improve access to life-saving overdose-reversal medications like naloxone, and pass legislation that sets guidelines or limits for opioid prescriptions. '
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ThemeNavFooter2.default, { themes: data.allThemesJson.edges }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section section__notes' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'ol',
	            { start: '19', style: { counterReset: 'item 18' }, className: 'list__notes' },
	            _react2.default.createElement(
	              'li',
	              { id: '19' },
	              'Steven H. Woolf and Heidi Schoomaker \u201C',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://jamanetwork.com/journals/jama/article-abstract/2756187' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Life Expectancy and Mortality Rates in the United States,1959\u20132017'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'JAMA'
	              ),
	              ' 322, no. 20 (Nov. 26, 2019): 1996\u20132016.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '20' },
	              'Anne Case and Angus Deaton, ',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://press.princeton.edu/books/hardcover/9780691190785/deaths-of-despair-and-the-future-of-capitalism' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Deaths of Despair and the Future of Capitalism'
	                )
	              ),
	              ' (Princeton University Press, 2020).'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '21' },
	              'Farida B. Ahmad, Lauren M. Rossen, and Paul Sutton, ',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://www.cdc.gov/nchs/nvss/vsrr/drug-overdose-data.htm' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Provisional Drug Overdose Death Counts'
	                  )
	                )
	              ),
	              ' (National Center for Health Statistics, 2020).'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '22' },
	              'Christopher J. Ruhm, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.ncbi.nlm.nih.gov/pubmed/25839783' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Recessions, Healthy No More?'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Journal of Health Economics'
	              ),
	              ' 42 (July 2015): 17\u201328; Erin C. Strumpf et al., \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.sciencedirect.com/science/article/abs/pii/S0277953617304495' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Did the Great Recession Affect Mortality Rates in the Metropolitan United States? Effects on Mortality by Age, Gender and Cause of Death'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Social Science and Medicine'
	              ),
	              ' 189 (Sept. 2017): 11\u201316; Atheendar S. Venkataramani et al., \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://jamanetwork.com/journals/jamainternalmedicine/fullarticle/2757788' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Association Between Automotive Assembly Plant Closures and Opioid Overdose Mortality in the United States: A Difference in-Differences Analysis'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'JAMA Internal Medicine'
	              ),
	              ' 180, no. 2 (Dec. 2019): 254\u201362; Kathleen A. Cagney et al., \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://ajph.aphapublications.org/doi/10.2105/AJPH.2013.301566' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'The Onset of Depression During the Great Recession: Foreclosure and Older Adult Mental Health'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'American Journal of Public Health'
	              ),
	              ' 104, no. 3 (Mar. 2014): 498\u2013505; Alex Hollingsworth, Christopher J. Ruhm, and Kosali Simon, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.nber.org/papers/w23192.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Macroeconomic Conditions and Opioid Abuse'
	                )
	              ),
	              ',\u201D Working Paper 23192 (National Bureau of Economic Research, March 2017).'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '23' },
	              'Douglas Belkin, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.wsj.com/articles/nations-top-mental-health-official-warns-against-a-second-coronavirus-lockdown-11590066006' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Nation\u2019s Top Mental-Health Official Warns Against a Second Coronavirus Lockdown'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Wall Street Journal,'
	              ),
	              ' May 21, 2020; Stephen Petterson, John M. Westfall, and Benjamin F. Miller, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://wellbeingtrust.org/wp-content/uploads/2020/05/WBT_Deaths-of-Despair_COVID-19-FINAL-FINAL.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Projected Deaths of Despair During the Coronavirus Recession'
	                  )
	                )
	              ),
	              ' (WellBeing Trust, May 2020); Brianna Ehley, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.politico.com/news/2020/06/29/pandemic-unleashes-a-spike-in-overdose-deaths-345183' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Pandemic Unleashes a Spike in Overdose Deaths'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Politico,'
	              ),
	              ' updated July 2, 2020; and Jesse C. Baumgartner, Gabriella N. Aboulafia, and Sara R. Collins, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.commonwealthfund.org/blog/2020/implications-covid-19-opioid-related-mortality' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'The Implications of COVID-19 for Opioid-Related Mortality,'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'To the Point'
	              ),
	              ' (blog), Commonwealth Fund, Aug. 28, 2020.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '24' },
	              'Jesse C. Baumgartner, Gabriella N. Aboulafia, and Audrey McIntosh, \u201C',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://www.commonwealthfund.org/blog/2020/aca-10-how-has-it-impacted-mental-health-care' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'The ACA at 10: How Has It Impacted Mental Health Care?'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'To the Point'
	              ),
	              ' (blog), Commonwealth Fund, Apr. 3, 2020.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '25' },
	              'Hefei Wen et al., \u201C',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://pubmed.ncbi.nlm.nih.gov/28296674/' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Impact of Medicaid Expansion on Medicaid-Covered Utilization of Buprenorphine for Opioid Use Disorder Treatment'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Medical Care'
	              ),
	              ' 55, no. 4 (Apr. 2017): 336\u201341.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '26' },
	              'Nicole Kravitz-Wirtz et al., \u201C',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2758476' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Association of Medicaid Expansion with Opioid Overdose Mortality in the United States'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'JAMA Network Open'
	              ),
	              ' 3, no. 1 (Jan. 2020): e1919066; and Hefei Wen et al., \u201C',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://pubmed.ncbi.nlm.nih.gov/32202609/' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  '\u201CAssociation Between Medicaid Expansion and Rates of Opioid Related Hospital Use'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'JAMA Internal Medicine'
	              ),
	              ' 180, no. 5 (Mar. 23, 2020): 753\u201359.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '27' },
	              'Kenneth D. Kochanek, Robert N. Anderson, and Elizabeth Arias, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.cdc.gov/nchs/data/hestat/life-expectancy/life-expectancy-2018.htm' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Changes in Life Expectancy at Birth, 2010\u20132018'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'NCHS E-Stat'
	              ),
	              ', National Center for Health Statistics, updated Jan. 30, 2020.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '28' },
	              'Only Oklahoma had a change that exceeded + or - 0.5 standard deviations to meet our definition of \u201Cmeaningful change\u201D during this period.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '29' },
	              'Jennifer Karas Montez et al., \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://onlinelibrary.wiley.com/doi/full/10.1111/1468-0009.12469' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'U.S. State Policies, Politics, and Life Expectancy'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Milbank Quarterly,'
	              ),
	              ' published online Aug. 4, 2020.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '30' },
	              'David C. Radley, \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.commonwealthfund.org/blog/2019/americans-die-prematurely-treatable-causes' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Diving into the Data: How Many Americans Die Prematurely from Treatable Causes?'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'To the Point'
	              ),
	              ' (blog), Commonwealth Fund, Aug. 6, 2019.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '31' },
	              'Reis Thebault et al., \u201C',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.washingtonpost.com/graphics/2020/investigations/coronavirus-excess-deaths-heart/' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Heart Conditions Drove Spike in Deaths Beyond Those Attributed to COVID-19, Analysis Shows'
	                )
	              ),
	              ',\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Washington Post,'
	              ),
	              ' July 2, 2020.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '32' },
	              'Trust for America\u2019s Health, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.tfah.org/report-details/publichealthfunding2020/' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'The Impact of Chronic Underfunding on America\u2019s Public Health System: Trends, Risks, and Recommendations'
	                  )
	                )
	              ),
	              ' (TFAH, Apr. 2020).'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	//  Components
	exports.default = Theme3Page;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-deaths-js-967778e4c29dbbbde965.js